import React, { FC, useContext } from 'react';

import { FeatureFlag } from 'app/api/services/site-configs/types';

import { Modal } from 'app/design-system/components/Modal';
import { Tabs, TabsSize } from 'app/design-system/components/Tabs';
import { useTranslation } from 'app/lang';
import { useFeatureFlag } from 'app/lib/feature-flags';

import { getModalSigningTabsOptions, ModalSigningTab } from '../constants';
import { RegContext } from '../context';
import { getHeaderContent } from '../utils/registration-helpers';

import styles from '../Signing.module.scss';

type HeaderProps = {
  activeTab: ModalSigningTab;
  changeTab: (tab: ModalSigningTab) => void;
};

const Header: FC<HeaderProps> = ({
  activeTab,
  changeTab,
}) => {
  const { t } = useTranslation();
  const { regData } = useContext(RegContext);
  const isAllowReg = useFeatureFlag(FeatureFlag.ALLOW_REGISTRATION);
  const CONTENT = t(getHeaderContent(regData));
  const signingTabsOptions = getModalSigningTabsOptions(t, isAllowReg);

  return (
    <Modal.Header data-test="Modal-Signing-header">
      <div data-test="header-title">
        {activeTab === ModalSigningTab.REGISTRATION && regData.regStep !== 1 ? CONTENT : (
          <Tabs<ModalSigningTab>
            type="button"
            activeTabId={activeTab}
            tabs={signingTabsOptions}
            size={TabsSize.MEDIUM}
            onChange={changeTab}
            className={styles.tabs}
            data-test="Modal-Signing-headerTabs" />
        )}
      </div>
    </Modal.Header>
  );
};

export default Header;
